export default __webpack_public_path__ + "static/media/icon-kiosk-thanks.3b3b3d7b.svg";